function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var More = function More(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M4.313 9a3.316 3.316 0 0 1 3.313 3.312 3.315 3.315 0 0 1-3.313 3.31A3.315 3.315 0 0 1 1 12.313 3.316 3.316 0 0 1 4.313 9m15.485 0a3.316 3.316 0 0 1 3.313 3.312 3.316 3.316 0 0 1-3.313 3.31 3.315 3.315 0 0 1-3.313-3.31A3.316 3.316 0 0 1 19.798 9m-7.743 0a3.316 3.316 0 0 1 3.313 3.312 3.315 3.315 0 0 1-3.313 3.31 3.315 3.315 0 0 1-3.313-3.31A3.316 3.316 0 0 1 12.055 9m-7.742 2C3.59 11 3 11.589 3 12.312a1.313 1.313 0 0 0 2.626 0c0-.723-.588-1.312-1.313-1.312m15.485 0c-.725 0-1.313.589-1.313 1.312a1.313 1.313 0 0 0 2.625 0c0-.723-.588-1.312-1.312-1.312m-7.743 0c-.725 0-1.313.589-1.313 1.312a1.313 1.313 0 0 0 2.626 0c0-.723-.589-1.312-1.313-1.312"
  }));
};
export default More;